/**
 * @generated SignedSource<<548cb26854da8625e751e8098366f6a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountSelectionPanel_AuthViewerSchemaFragment$data = {
  readonly currentUser: {
    readonly accounts: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly user: {
      readonly name: string;
    };
  } | null;
  readonly " $fragmentType": "accountSelectionPanel_AuthViewerSchemaFragment";
};
export type accountSelectionPanel_AuthViewerSchemaFragment$key = {
  readonly " $data"?: accountSelectionPanel_AuthViewerSchemaFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountSelectionPanel_AuthViewerSchemaFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountSelectionPanel_AuthViewerSchemaFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Account",
          "kind": "LinkedField",
          "name": "accounts",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthViewerSchema",
  "abstractKey": null
};
})();

(node as any).hash = "6149e7a6f5505978f78591dd9c222794";

export default node;
